export const fiscalRegime = [
  { code: 'LP', label: 'Lucro Presumido'},
  { code: 'LR', label: 'Lucro Real'},
  { code: 'SN', label: 'Simples Nacional'},
];
